import { IIG_CTA } from "../ctaConstants";

const getCTAs = () => {
  let resp = {
    isApp: false,
    success: true,
    callToActions: [IIG_CTA],
  };

  return resp;
};

export default getCTAs;
